import loadable from '@loadable/component'

const SuccessContent = loadable(() => import('./Success'))
const PhoneContent = loadable(() => import('./Phone'))
const CodeContent = loadable(() => import('./Code'))

export { CodeContent, PhoneContent, SuccessContent }
